// Where game files come from. Production: GitHub. Tests on localhost may point these at a mock server by
// setting localStorage["rtw:test-endpoints"] = '{"api":"http://localhost:8790/api","raw":"http://localhost:8790/raw"}'.
// The override is ignored on any non-localhost hostname, and the production CSP would block it anyway.

export interface Endpoints { api: string; raw: string }

export const GITHUB: Endpoints = { api: 'https://api.github.com', raw: 'https://raw.githubusercontent.com' };

export function isLocalHostname(h: string): boolean {
  return h === 'localhost' || h.endsWith('.localhost') || h === '127.0.0.1';
}

export function getEndpoints(loc: { hostname: string } = location, storage: Pick<Storage, 'getItem'> | null = safeStorage()): Endpoints {
  if (!isLocalHostname(loc.hostname) || !storage) return GITHUB;
  try {
    const raw = storage.getItem('rtw:test-endpoints');
    if (!raw) return GITHUB;
    const v = JSON.parse(raw) as Partial<Endpoints>;
    const local = (u: unknown) => typeof u === 'string' && /^http:\/\/(localhost|127\.0\.0\.1)(:\d+)?(\/|$)/.test(u);
    if (local(v.api) && local(v.raw)) return { api: v.api!.replace(/\/$/, ''), raw: v.raw!.replace(/\/$/, '') };
  } catch { /* ignore */ }
  return GITHUB;
}

function safeStorage(): Storage | null {
  try { return globalThis.localStorage ?? null; } catch { return null; }
}
